var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-contianer AppDownload"},[_c('div',{staticClass:"download-but",on:{"click":function($event){return _vm.checkSys()}}},[_c('a',{attrs:{"href":_vm.downloadUrl}},[_vm._v(_vm._s(_vm.osType === 'ANDROID' ? 'Android':'IOS')+"下载")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }